var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.5c-.275 0-.5.225-.5.5v.69l5.39 4.426a1.75 1.75 0 0 0 2.223 0L16.5 6.69V6c0-.275-.225-.5-.5-.5zm-.5 3.131V14c0 .275.225.5.5.5h12c.275 0 .5-.225.5-.5V8.631l-4.437 3.644a3.25 3.25 0 0 1-4.126 0zM2 6c0-1.103.897-2 2-2h12c1.103 0 2 .897 2 2v8c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2z"
  })));
};
export default SvgEnvelope;